<template>
    <div class="h-full flex justify-center items-center">
        <div class="bg-primary-default w-full xs:w-3/4 mx-auto flex justify-center items-center text-white z-20 rounded-xl px-4 py-2 font-bold text-sm">
            {{ $t('elements_description_landscape') }}
        </div>
    </div>
</template>
